import { tss } from "tss-react/mui";
import { DEFAULT_LEFT_PADDING, DEFAULT_RIGHT_PADDING, MOBILE_LEFT_PADDING, MOBILE_RIGHT_PADDING, WINDOW_MAX_WIDTH } from "../../../layout/Layout.styles";

export const useStyles = tss.create(({ theme }) => ({
	root: {
		position: 'relative',
		overflow: 'hidden',
		[theme.breakpoints.down('md')]: {
			backgroundColor: '#F9F9FB',
		}
	},
	container: {
		margin: '0 auto',
		maxWidth: WINDOW_MAX_WIDTH,
		paddingLeft: DEFAULT_LEFT_PADDING,
		paddingRight: DEFAULT_RIGHT_PADDING,
		paddingBottom: 24,
		paddingTop: 48,
		overflow: 'hidden',
		'& > div': {
			textAlign: 'center',
		},
		[theme.breakpoints.down('md')]: {
			paddingLeft: MOBILE_LEFT_PADDING,
			paddingRight: MOBILE_RIGHT_PADDING,
			paddingBottom: 35,
			paddingTop: 20,
		}
	},
	containerPosts: {
		flexWrap: 'wrap',
	},
	emptyContainer: {
	},
	post: {
		boxShadow: 'none',
		border: '1px solid #D5D5D5',
		flexDirection: 'column',
		flexWrap: 'nowrap',
		overflow: 'hidden',
		'& div:nth-child(2)': {
			flex: '1 0 auto'
		},
		[theme.breakpoints.down('md')]: {
			marginBottom: 0,
		}
	},
	postContainer: {
		display: 'flex',
	},
	emptyState: {
		flexDirection: 'column',
		alignItems: 'center',
		gap: 8,
	},
	emptyTitle: {
		fontsize: 14,
		lineHeight: "24px",
		color: "#8892A0",
		fontWeight: 'bold'
	},
	emptySubtitle: {
		fontsize: 14,
		lineHeight: "24px",
		color: "#8892A0",
		textAlign: 'center'
	},
	readMoreButton: {
		height: 36,
		width: 277,
		maxWidth: '100%',
		marginTop: 40,
	}
}))